import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Dropdown } from '@atoms';
import messages from './messages';

export default class ChangeAnalyst extends PureComponent {
  static propTypes = {
    users: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string,
      }),
    ).isRequired,
    isLoading: PropTypes.bool.isRequired,
    loadUsers: PropTypes.func.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    changeAnalyst: PropTypes.func.isRequired,
    analystId: PropTypes.number,
  };

  componentDidMount() {
    this.props.loadUsers();
  }

  render() {
    const { users, analystId, changeAnalyst, isSuperAdmin } = this.props;
    return (
      isSuperAdmin && (
        <Dropdown
          id="change-analyst"
          label={<FormattedMessage {...messages.analysts} />}
          options={users}
          value={analystId}
          onChange={changeAnalyst}
        />
      )
    );
  }
}



// WEBPACK FOOTER //
// ./components/organisms/ChangeAnalyst/ChangeAnalyst.js